import { ExpenseDetail } from '@app/_components/expense/components/expense-detail/expense-detail';
import { ExpenseDetailService } from '@app/_components/expense/components/expense-detail/expense-detail.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ReservationLedgerService } from '@app/_components/reservation/components/reservation-ledger/reservation-ledger.service';
import { first } from 'rxjs';
import { ExpenseService } from '@app/_components/expense/expense.service';
import { PropertyService } from '@app/_components/property/property.service';

@Component({
    selector: 'app-expense-detail',
    templateUrl: './expense-detail.component.html',
    styleUrls: ['./expense-detail.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ExpenseDetailComponent implements OnInit {
	orderProducts: any[]=[];
	expenseId: any;
	markupTypes: any;
	vendors: any;
	paidBys: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private expenseDetailService: ExpenseDetailService,
		private reservationLedgerService: ReservationLedgerService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private expenseService: ExpenseService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.expenseDetail = data.expenseDetail,
			this.expenseId = data.expenseId,
			this.statuses = expenseService.statuses;
			this.markupTypes = expenseDetailService.markupTypes;
			this.vendors = expenseService.vendors;
			this.paidBys = expenseDetailService.paidBys;
	}

	@Input() expenseDetail: ExpenseDetail;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	expenseDetailId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'expenseDetailId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'expenseDetailDate': [],
		'opsNotes': [],
		'quantity': [],
		'amount': [
			{ type: 'required', message: 'Required' }
		],
		'expenseId': [],
		'orderProductId': [
			{ type: 'required', message: 'Required' }
		],
		vendorUpdateDateTime:[],
		expenseVendor:[],
		expenseVendorId:[],
		markUpType:[],
		markUpAMT:[],
		markUpPCT:[],
		paidBy: [
			{ type: 'required', message: 'Required' }
		]

	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.findAllOrderProducts();

		// if we were passed the whole expenseDetail object
		if (this.expenseDetail) {
			this.expenseDetailId = this.expenseDetail.expenseDetailId;
			if(this.expenseDetail.vendorUpdateDateTime != undefined && this.expenseDetail.vendorUpdateDateTime != null){
				this.expenseDetail.vendorUpdateDateTime = moment.utc(this.expenseDetail.vendorUpdateDateTime).toDate();
			}
			this.fixDates();
			this.form1.patchValue(this.expenseDetail);
			if(this.expenseDetail.markUpPCT >= 1 && this.expenseDetail.markUpType == 1){
				this.form1.patchValue({
					markUpPCT: this.expenseDetail.markUpPCT / 100
				});
			}
			
			
		}
	}

	

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.expenseDetailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.expenseDetailService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.expenseDetail = res.data.expenseDetail;
						this.doAdd.emit(this.expenseDetail);
						this.formLoading = false;
					},
					(err: any) => {
						console.log('expenseDetail-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
						this.formLoading = false;
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	formUpdate() {
		console.log('expenseDetail: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.expenseDetailService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.expenseDetail = res.data.expenseDetail;
						this.doUpdate.emit(this.expenseDetail);
						this.formLoading = false;
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
						this.formLoading = false;
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	formDelete() {
		try {
			this.formLoading = true;
			this.expenseDetailService.delete(this.expenseDetail.expenseDetailId)
				.subscribe(
					(res: any) => {
						console.log('expenseDetail-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.expenseDetail);
						this.formLoading = false;
					},
					(err: any) => {
						console.log('expenseDetail-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
						this.formLoading = false;
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.formLoading = false;
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			expenseDetailId: [this.expenseDetailId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			expenseDetailDate: [],
			opsNotes: [],
			quantity: [1],
			amount: [null, Validators.required],
			expenseId: [this.expenseId],
			orderProductId: [null, Validators.required],
			vendorUpdateDateTime:[],
			expenseVendor:[1],
			expenseVendorId:[],
			markUpType:[],
			markUpAMT:[],
			markUpPCT:[],
			paidBy:[null, Validators.required]
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.expenseDetail.expenseDetailDate = moment(this.expenseDetail.expenseDetailDate).toDate();
	}

	findAllOrderProducts() {
		this.reservationLedgerService.findExpenseOrderProduct().pipe(first()).subscribe(
			res => {
				this.orderProducts = res.data.orderProducts;
			},
			err => {
				console.log('error In findReservationLedgerById is: ' + JSON.stringify(err));
				this.formLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve the order products.' + err.message, sticky: false });
			},
			() => { this.formLoading = false; });
	}

	onProductSelect($event: any) {
		if(this.orderProducts){
			let filteredOrderProduct = this.orderProducts.filter(orderProduct =>
			{
				return orderProduct.orderProductId === this.form1.value?.orderProductId;
			});
			if(filteredOrderProduct.length > 0){
				let selectedOrderProduct = filteredOrderProduct[0];
				this.form1.value.description =  selectedOrderProduct?.description;
				this.form1.value.orderProductId = selectedOrderProduct?.orderProductId;
				this.form1.patchValue({
					description: selectedOrderProduct?.description
				});
			}
		}
	}
}
